import { render } from "./gallery-flip.vue?vue&type=template&id=e1f2fa68"
import script from "./gallery-flip.vue?vue&type=script&lang=js"
export * from "./gallery-flip.vue?vue&type=script&lang=js"

import "./gallery-flip.vue?vue&type=style&index=0&id=e1f2fa68&lang=css"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__